import { ToolCard } from "./components/ToolCard";
import { TOOLS } from "./tools.data";
import styles from "./ToolsPage.module.css";

/**
 * Tools — a directory of the tools available to the team, shown as a responsive
 * grid of cards. Presentational for now; cards gain behaviour as tools come online.
 */
export function ToolsPage() {
  return (
    <div className={styles.page}>
      <div className={styles.grid}>
        {TOOLS.map((tool) => (
          <ToolCard key={tool.id} tool={tool} />
        ))}
      </div>
    </div>
  );
}
